import React from 'react';
import { colors } from 'Constants/Colors';
import { Paper, TextField } from '@mui/material';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { CustomDatePickerContainer, CustomDatePickerLabel } from './CustomDatePicker.styled';

interface Props {
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const CustomDatePicker = ({ label, value, onChange, placeholder }: Props) => {
  return (
    <CustomDatePickerContainer>
      <CustomDatePickerLabel hidden={!label}>{label}</CustomDatePickerLabel>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Paper
          variant="outlined"
          sx={{
            padding: '0.5rem',
            alignItems: 'center',
            display: 'flex',
            gap: '0.5rem',
            height: '50px',
            width: '150px',
          }}
        >
          <DatePicker
            value={value}
            onChange={onChange}
            inputFormat="dd/MM/yyyy"
            renderInput={params => (
              <TextField
                {...params}
                placeholder={placeholder}
                variant="standard"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  style: { color: value ? 'black' : colors.GRAY },
                  sx: {
                    '& input': {
                      padding: 0,
                      cursor: 'pointer',
                      '&::placeholder': {
                        color: colors.GRAY,
                        opacity: 1,
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Paper>
      </LocalizationProvider>
    </CustomDatePickerContainer>
  );
};

export default CustomDatePicker;
